RivalIQ.apps.Favorites.module('views.forms', function (forms, App, Backbone, Marionette, $, _) {

    'use strict';

    const SelectField = RivalIQ.views.Select.extend({
        onChange: function (value) {
            const me = this;
            const props = _.set({}, [me.prop], value);
            me.dashboardModel.setProps(props);
        },
        initialize: function (options) {
            const me = this;

            _.extend(me, options);

            const items = _.get(options, 'items', me.items);
            me.items = items;
            if (_.isFunction(items)) {
                me.items = items.call(me);
            }

            if (_.isUndefined(me.selected) || _.isNull(me.selected)) {
                me.selected = me.dashboardModel.getProp(me.prop);
            }
        }
    });

    const TextField = RivalIQ.views.ItemView.mixin({
        tagName: 'input',
        template: false,
        className: 'form-control',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        eventsNotToDebounce: {
            'keydown': 'onKeydown',
            'blur': 'onBlur'
        },
        updateProp: function () {
            const me = this;
            const props = _.set({}, me.getOption('prop'), me.$el.val());
            me.dashboardModel.setProps(props);
        },
        onKeydown: function (e) {
            const me = this;
            if (e.which === 13) {
                e.preventDefault();
                me.updateProp();
            }
        },
        onBlur: function () {
            const me = this;
            me.updateProp();
        },
        onRender: function () {
            const me = this;

            const prop = me.getOption('prop');
            const value = me.dashboardModel.getProp(prop);
            if (value) {
                me.$el.val(value);
            }
        }
    });


    const PostTagIdsField = RivalIQ.apps.SocialPosts.views.PostTagsFilter.extend({
        updateProp: function (newProps) {
            const me = this;

            me.dashboardModel.setProps(newProps, {
                navigate: false
            });
            me.render();
        },

        _getItemStr: function (postTagHtml) {
            return $.tagHtml('span', {
                class: ['tag-name'],
                html: postTagHtml
            });
        },

        onRender: function () {
            const me = this;

            if (me.fieldEnabled && !me.fieldEnabled()) {
                me.ui.dropdownToggle.addClass('disabled');

                me.ui.dropdown.popover({
                    trigger: 'hover',
                    placement: 'auto',
                    container: 'body',
                    content: me.disabledReasonMessage
                });
            }

            me.resetState();
        }
    });

    const SwitchField = RivalIQ.views.ItemView.mixin({
        template: '#favoritesChartBuilderSwitchTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            option: 'label'
        },

        eventsNotToDebounce: {
            'change @ui.option': 'onOptionChange'
        },

        serializeData: function () {
            const me = this;

            return {
                switchOptions: me.switchOptions,
                currentValue: me.getProp(me.getOption('prop'))
            };
        },

        onOptionChange: function (e) {
            const me = this;

            const $target = $(e.target);

            const option = _.find(me.switchOptions, {
                id: $target.data('option-id')
            });

            const props = _.set({}, me.getOption('prop'), option.value);
            me.dashboardModel.setProps(props, {
                navigate: false
            });

            e.preventDefault();
            return false;
        }
    });

    forms.fieldType = {};

    forms.fieldType.metrics = {
        type: 'metrics',
        title: 'Metric',
        description: RivalIQ.strings.favorites_builder_metric_description
    };

    forms.fieldType.postFilter = {
        type: 'text',
        prop: 'searchTerm',
        title: 'Search Post Content',
        description: RivalIQ.strings.favorites_builder_list_query_description,
        tipsSetup: function (domEl) {
            domEl.html('<span class="search-tips-link small">Search tips</a>');
            RivalIQ.apps.SocialPosts.utils.setupSearchTipsPopover('custom_dashboards', domEl);
        }
    };

    forms.fieldType.postType = {
        type: 'select',
        prop: 'type',
        title: 'Post Type',
        description: RivalIQ.strings.favorites_builder_list_post_type_description,
        items: [
            {
                id: undefined,
                name: 'All Media'
            },
            {
                id: 'gif',
                name: 'GIF'
            },
            {
                id: 'photo',
                name: 'Photo'
            },
            {
                id: 'link',
                name: 'Link'
            },
            {
                id: 'status',
                name: 'Status Update'
            },
            {
                id: 'video',
                name: 'Video'
            }
        ]
    };

    function channelOptionRenderer(item) {
        const template = Marionette.TemplateCache.get('#favoritesChannelOptionTemplate');
        const result = template(item);
        return result;
    }

    forms.fieldType.source = {
        type: 'select',
        prop: 'source',
        title: 'Source',
        description: RivalIQ.strings.favorites_builder_source_description,
        itemRenderer: channelOptionRenderer,
        items: function () {
            const me = this;
            const validChannels = me.dashboardModel.getValidChannels().toJSON();
            return validChannels;
        },
        onChange: function (source) {
            const me = this;
            const metric = me.dashboardModel.baseMetric;

            const channel = RivalIQ.data.channels.get(source);
            let channelName = channel.get('channel');
            if (channel.isCrossChannel()) {
                channelName = undefined;
            }

            metric.channel = channelName;
            me.dashboardModel.setProps({
                metrics: me.dashboardModel.getProp('defaultMetrics'),
                channel: metric.channel
            }, {
                silent: true,
                navigate: false
            });

            me.dashboardModel.setBaseMetric(metric);
        }
    };

    // This is similar to the source fieldType, but it just deals with source (doesn't mess around with channel at all).
    forms.fieldType.source_only = {
        type: 'select',
        prop: 'source',
        title: 'Source',
        description: RivalIQ.strings.favorites_builder_source_description,
        itemRenderer: channelOptionRenderer,
        items: function () {
            const me = this;
            const validChannels = me.dashboardModel.getValidChannels().toJSON();
            return validChannels;
        },
        onChange: function (source) {
            const me = this;
            const metric = me.dashboardModel.baseMetric;

            metric.source = source;
            me.dashboardModel.setProps({
                metrics: me.dashboardModel.getProp('defaultMetrics'),
                source: source
            }, {
                silent: true,
                navigate: false
            });

            me.dashboardModel.setBaseMetric(metric);
        }
    };

    forms.fieldType.postTagIds = {
        type: 'posttagids',
        prop: 'postTagIds',
        title: 'Post Tags',
        enableFocusCompany: true,
        description: RivalIQ.strings.favorites_builder_posttagids_description,

        className: function () {
            return `${_.result(RivalIQ.apps.SocialPosts.views.PostTagsFilter.prototype, ['className'])} favorites-multi-select-dropdown`;
        },

        loadData: function () {
            const field = this;

            // Note: this `field.set` check is because loadData is called once by the view itself and once by `Field` and they are different
            // object types (the latter has a .set method).
            return RivalIQ.postTags.data.PostTags.fetch()
                .then(function (postTags) {
                    field.set && field.set({
                        postTagsById: _.keyBy(postTags, 'id'),
                        postTagIds: {}
                    });
                });
        },

        fieldEnabled: function () {
            const me = this;
            return me.dashboardModel.configuration.get('type') !== RivalIQ.enums.visibility.ACCOUNT;
        },

        disabledReasonMessage: RivalIQ.strings.favorites_builder_posttagids_account_warning
    };

    forms.fieldType.postTagVisibility = {
        type: 'switch',
        prop: 'showPostTags',
        title: 'Post Tags Visibility',
        enableFocusCompany: true,
        description: RivalIQ.strings.favorites_builder_show_post_tags_description,

        switchOptions: [{
            id: 'show',
            name: 'Show',
            value: true
        }, {
            id: 'hide',
            name: 'Hide',
            value: false
        }]
    };

    forms.fieldType.privatePresence = {
        type: 'select',
        prop: 'companyId',
        title: 'Company',
        enableFocusCompany: true,
        description: RivalIQ.strings.favorites_builder_source_description,
        loadData: function () {
            const field = this;
            const widget = field.get('widget');
            return RivalIQ.data.privateMetadata.fetch(widget.getProps())
                .then(function (metadata) {
                    // TODO validate with @lintiff that we want to filter
                    // companies to the current landscape
                    const selectableCompanies = _.reduce(metadata.companies, function (memo, presence) {
                        const company = RivalIQ.state.landscape.get('companies').get(presence.id);
                        if (company) {
                            return memo.concat({
                                id: presence.id,
                                name: company.get('name'),
                                presenceId: presence.presenceId
                            });
                        }
                        return memo;
                    }, []);

                    // NOTE if we support using the "Focus Company" alias then
                    // we need to make sure in the context of the builder that
                    // we look at the curation props (since the widget props
                    // will apply the default) to determine if we are in that
                    // state
                    let companyId = widget.getProp('companyId');
                    if (field.get('enableFocusCompany')) {
                        companyId = widget.curation.getProp('companyId');
                    }
                    const selected = _.find(selectableCompanies, function (company) {
                        return (company.id === companyId);
                    });

                    const items = selectableCompanies;
                    if (field.get('enableFocusCompany')) {
                        items.splice(0, 0, {
                            id: undefined,
                            name: 'Focus Company'
                        });
                    }

                    field.set({
                        items: items,
                        selected: _.get(selected, ['id'])
                    });
                });
        }
    };

    (function () {

        const Types = RivalIQ.views.SocialPostGrid.types;

        forms.fieldType.layout = {
            type: 'select',
            prop: 'layout',
            title: 'Layout',
            description: RivalIQ.strings.favorites_builder_list_layout_description,
            items: [
                {
                    id: undefined,
                    name: 'List'
                },
                {
                    id: Types.grid,
                    name: 'Grid'
                },
                {
                    id: Types.gridWithDetails,
                    name: 'Grid with Details'
                },
                {
                    id: Types.mosaic,
                    name: 'Mosaic'
                },
                {
                    id: Types.mosaicWithDetails,
                    name: 'Mosaic with Details'
                }
            ]
        };

    }());

    const Field = RivalIQ.views.LayoutView.mixin({
        regions: {
            field: '.x-field'
        },
        ui: {
            field: '.x-field',
            tipsContainer: '.x-tips-container'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        template: '#builderFieldTemplate',

        dashboardModelEvents: {
            'change:baseMetric': 'onBaseMetricChanged'
        },

        className: function () {
            const me = this;
            const size = (me.model.get('size') || 3);
            let className = (me.model.get('className') || '');
            if (_.isFunction(className)) {
                className = className();
            }
            return [className, ['col', 'xs', size].join('-')].join(' ');
        },
        serializeData: function () {
            const me = this;
            const model = me.model;
            return _.defaults(model.toJSON(), {
                name: model.get('prop')
            });
        },
        loadData: function () {
            const me = this;
            const field = me.model;
            if (field.has('loadData')) {
                return field.attributes.loadData.call(field);
            }
            return $.when();
        },
        onRenderLoaded: function () {
            const me = this;

            const model = me.model;
            const prop = model.get('prop');
            const type = model.get('type');

            if (type === 'select') {
                const Cls = SelectField.extend(model.toJSON());
                new Cls({
                    el: me.ui.field,
                    dashboardModel: me.dashboardModel
                }).render();
            } else if (type === 'text') {
                me.ui.field.empty().append(new TextField({
                    attributes: {
                        name: (model.get('name') || prop)
                    },
                    prop: prop,
                    dashboardModel: me.dashboardModel
                }).render().$el);
            } else if (type === 'metrics') {
                me.renderMetrics();
            } else if (type === 'posttagids') {
                const PostTagIdsCls = PostTagIdsField.extend(model.toJSON());
                const postTagFilter = new PostTagIdsCls({
                    el: me.ui.field,
                    dashboardModel: me.dashboardModel
                });
                postTagFilter.render();
                postTagFilter.onShow();
            } else if (type === 'switch') {
                const SwitchFieldCls = SwitchField.extend(model.toJSON());
                new SwitchFieldCls({
                    el: me.ui.field,
                    dashboardModel: me.dashboardModel
                }).render();
            }

            const tipsSetup = model.get('tipsSetup');
            if (tipsSetup) {
                tipsSetup(me.ui.tipsContainer);
            }

            const isHidden = model.get('isHidden');
            if (isHidden) {
                me.$el.toggleClass('display-none', isHidden.call(me.model, me));
            }
        },
        onBaseMetricChanged: function () {
            const me = this;

            const model = me.model;
            const type = model.get('type');

            if (me.model.has('onBaseMetricChanged')) {
                me.model.get('onBaseMetricChanged').call(me.model, me);
            } else if (type === 'metrics') {
                me.renderMetrics();
            }
        },
        renderMetrics: function () {
            const me = this;

            const model = me.model;
            const metrics = model.get('metrics');
            const context = me.getOption('context');

            function onMetricChange() {
                context.onMetricsChange(metrics.toMetrics(me.dashboardModel.baseMetric));
            }

            me.listenTo(metrics, 'update', onMetricChange);
            me.listenTo(metrics, 'change', onMetricChange);
            me.listenTo(metrics, 'sort', onMetricChange);

            me.field.show(new App.views.MetricsView({
                hideLabel: true,
                source: false,
                timeAnalysisMode: false,
                collection: metrics,
                dashboardModel: me.dashboardModel
            }));
        }
    });

    forms.List = RivalIQ.views.LayoutView.mixin({
        template: '#favoritesListBuilderTemplate',

        regions: {
            controls: '.x-controls'
        },

        ui: {
            focusWidgetSelector: '.x-focus-widget-selector',
            types: 'select[name="focusWidgetId"]'
        },

        dashboardModelEvents: {
            'changed:metrics': 'onMetricsChanged'
        },

        behaviors: {
            Localizable: {},
            AttributeBuilder: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        onRenderLoaded: function () {
            const me = this;

            me.graphSelector = new App.views.selectors.Widget({
                el: me.ui.types,
                dashboardModel: me.dashboardModel
            });

            let shouldRenderGraphs = true;
            if (me.hideEmptyGraphSelector) {
                const hasMultipleVisualizations = (_.size(me.graphSelector.items) > 1);
                me.ui.focusWidgetSelector.toggleClass('display-none', !hasMultipleVisualizations);
                shouldRenderGraphs = hasMultipleVisualizations;
            }

            if (shouldRenderGraphs) {
                me.graphSelector.render();
            }

            me.buildControls();
        },

        getFields: function () {
            const me = this;

            if (me._fields) {
                return me._fields;
            }

            const widget = me.dashboardModel.getWidget();
            const fields = _.map(widget.getBuilderFields(), function (field) {
                const fieldType = (forms.fieldType[field.type] || {
                    type: field.type
                });
                // NOTE we allow you to override properties from the `fieldType`
                return _.extend({}, fieldType, _.omit(field, 'type'));
            });

            me._fields = new Backbone.Collection(fields);

            return me._fields;
        },

        buildControls: function () {
            const me = this;

            /*
             * {
             *     type: 'dropdown',
             *     name: 'type',
             *     title: 'Post Type'
             *     description: str("favorites_builder_list_post_type_description")
             * },
             * {
             *     type: 'post-type'
             * },
             */
            const CollectionView = RivalIQ.views.CollectionView.extend({
                childView: Field,
                childViewOptions: function () {
                    return {
                        context: me,
                        dashboardModel: me.dashboardModel
                    };
                }
            });

            const view = new CollectionView({
                dashboardModel: me.dashboardModel,
                collection: me.getFields()
            });

            me.controls.show(view);
        },

        onMetricsChanged: function () {
            const me = this;
            me.graphSelector.resetItems();
        },

        buildDropdowns: function () {
            const me = this;

            me.graphSelector = new App.views.selectors.Widget({
                el: me.ui.types,
                dashboardModel: me.dashboardModel
            });

            me.graphSelector.render();

            new App.views.selectors.Source({
                el: me.ui.source,
                dashboardModel: me.dashboardModel
            }).render();

            new App.views.selectors.PostType({
                el: me.ui.postType,
                dashboardModel: me.dashboardModel
            }).render();

            new App.views.selectors.Layout({
                el: me.ui.layout,
                dashboardModel: me.dashboardModel
            }).render();
        },

        showMetrics: function () {
            const me = this;

            const metricsCollection = new App.collections.Metrics(me.getProp('metrics'), {
                parse: true,
                baseMetric: me.dashboardModel.baseMetric,
                widget: me.dashboardModel.getWidget()
            });

            function onMetricChange() {
                me.onMetricsChange(metricsCollection.toMetrics(me.dashboardModel.baseMetric));
            }

            me.listenTo(metricsCollection, 'update', onMetricChange);
            me.listenTo(metricsCollection, 'change', onMetricChange);
            me.listenTo(metricsCollection, 'sort', onMetricChange);
            me.metricsRegion.show(new App.views.MetricsView({
                source: false,
                timeAnalysisMode: false,
                collection: metricsCollection,
                dashboardModel: me.dashboardModel
            }));
        },

        onAttachLoaded: function () {
            const me = this;
            me.initializePopovers();
        },

        onDomRefresh: function () {
            const me = this;
            me.initializePopovers();
        },

        onMetricsChange: function (metrics) {
            const me = this;

            const props = {
                metrics: metrics
            };
            me.setProps(props, {
                navigate: false
            });
        },

        serializeData: function () {
            const me = this;
            const focusWidget = me.dashboardModel.getWidget();
            return _.defaults(focusWidget.getProps(), {
                searchTerm: undefined
            });
        },

        templateHelpers: function () {
            const me = this;
            const focusWidget = me.dashboardModel.getWidget();

            return {
                // NOTE this method assumes that any list type metric will have
                // a free dimension that corresponds to the singular thing
                // (e.g., for Social Posts we will get "posts")
                getSubject: function () {
                    const freeDimensions = focusWidget.metric.getFreeDimensions();
                    return _.head(freeDimensions);
                }
            };
        },

        initializePopovers: function () {
            const me = this;
            me.$('[data-toggle="popover"]').popover({
                html: true,
                trigger: 'hover',
                placement: 'auto',
                container: 'body'
            });
        },

        updateWidget: function (props) {
            const me = this;
            me.dashboardModel.getWidget().setProps(props, {
                navigate: false
            });
        }
    });

});
